// 按标题找资料、挑进来（思考室挂资料、写作教练加知识参考共用）。
import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Popover } from 'antd'
import { FileText, Plus, Search } from 'lucide-react'
import { searchByName } from '../../api/search'
import type { Knowledge } from '../../api/types'
import { docTitle } from './DocCard'
import './attach.css'

export function AttachPicker({ picked, onPick, max, label, placement = 'bottomLeft' }: { picked: { id: string }[]; onPick: (k: Knowledge) => void; max: number; label?: string; placement?: 'bottomLeft' | 'topRight' }) {
  const [open, setOpen] = useState(false)
  const [q, setQ] = useState('')
  const [debounced, setDebounced] = useState('')
  useEffect(() => {
    const t = setTimeout(() => setDebounced(q.trim()), 250)
    return () => clearTimeout(t)
  }, [q])
  const hits = useQuery({ queryKey: ['attach-search', debounced], enabled: open && !!debounced, queryFn: () => searchByName(debounced, 10) })
  if (picked.length >= max) return null
  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger="click"
      placement={placement}
      arrow={false}
      content={
        <div className="attach-pop">
          <label className="sk-search">
            <Search width={16} height={16} />
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="按标题找资料" aria-label="按标题找资料" />
          </label>
          <div className="hits" role="listbox" aria-label="找到的资料">
            {(hits.data ?? []).filter((k) => !picked.some((p) => p.id === k.id)).map((k) => (
              <button
                key={k.id}
                type="button"
                role="option"
                aria-selected={false}
                className="hit"
                onClick={() => {
                  onPick(k)
                  setQ('')
                  setOpen(false)
                }}
              >
                <FileText width={14} height={14} />
                {docTitle(k)}
              </button>
            ))}
            {debounced && hits.isSuccess && !hits.data.length && <p className="sheet-note" style={{ padding: 8 }}>没有找到「{debounced}」</p>}
          </div>
        </div>
      }
    >
      <button type="button" className="attach-add">
        <Plus width={13} height={13} />
        {label ?? `添加资料（最多 ${max} 篇）`}
      </button>
    </Popover>
  )
}
